import styled from 'styled-components';
import { TabRootProps } from './Tab.types';

export const StyledTab = styled.button<TabRootProps>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 17px;
  width: ${({ width }) => width || '50%'};
  height: 36px;
  border-radius: 100px;
  gap: 8px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 36px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
  white-space: nowrap;

  color: ${({ active, theme }) => {
    const colors = theme[theme.color].Tab;

    if (active) return colors.colorActive;
    return colors.color;
  }};

  background-color: ${({ active, theme }) => {
    const colors = theme[theme.color].Tab;

    if (active) return colors.backgroundActive;
    return colors.background;
  }};

  &:hover {
    color: ${({ active, theme }) => {
      const colors = theme[theme.color].Tab;

      if (active) return colors.colorActiveHover;
      return colors.colorHover;
    }};

    background-color: ${({ active, theme }) => {
      const colors = theme[theme.color].Tab;

      if (active) return colors.backgroundActiveHover;
      return colors.backgroundHover;
    }};
  }
`;
